import token from 'styled-token';

/** @class GridContentMixin */
/** @method */
export var GridContentMixin = function GridContentMixin(props) {
  var backgroundToken = 'GridContent.backgroundColor';
  if (typeof props.backgroundColor !== 'undefined') {
    backgroundToken = "colors." + props.backgroundColor;
  }
  return token({
    backgroundColor: backgroundToken,
    borderRadius: 'GridContent.borderRadius'
  }, function (tokens) {
    var styles = ["border-radius: " + tokens.borderRadius + "px;"];
    if (tokens.backgroundColor) {
      styles.push("background-color: " + tokens.backgroundColor);
    }
    return styles;
  })(props);
};